import { Maybe, ProcessStatusGql } from '@iss/libs/graphql';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';

import { ProcessStatePipe } from '@iss/wo-common/pipes';

@Component({
  selector: 'wo-process-state',
  templateUrl: './process-state.component.html',
  styleUrls: [ './process-state.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    ProcessStatePipe,
  ],
})
export class ProcessStateComponent {
  @Input() public state: Maybe<ProcessStatusGql>;
  @Input() public extra: Maybe<string>;
  @Input() public small: Maybe<boolean>;

  public getCssClass(state: Maybe<ProcessStatusGql>): string {
    switch (state) {
      case ProcessStatusGql.New:
        return 'wo-process-state--new';
      case ProcessStatusGql.Running:
        return 'wo-process-state--running';
      case ProcessStatusGql.WaitingForRetry:
        return 'wo-process-state--waiting-for-retry';
      case ProcessStatusGql.Succeeded:
        return 'wo-process-state--succeeded';
      case ProcessStatusGql.Failed:
        return 'wo-process-state--failed';
      default:
        return '';
    }
  }
}
